import React, { Component } from 'react';
import { Link } from 'react-router';
import { auth, db } from '../ThirdPartyIntegration/firebaseClient'
import Grid from 'material-ui/Grid';
import Paper from 'material-ui/Paper';
import Typography from 'material-ui/Typography';
import TextField from 'material-ui/TextField';
import Button from 'material-ui/Button';

class Join extends Component {
    constructor() {
        super();
        this.state = {
            username: '',
            email: '',
            password: '',
            passwordConfirm: '',
            gender: 'female',
            orientation: 'straight'
        }

        // This binding is necessary to make `this` work in the callback
        this.onClickJoin = this.onClickJoin.bind(this);
        this.onChangeUsername = this.onChangeUsername.bind(this);
        this.onChangeEmail = this.onChangeEmail.bind(this);
        this.onChangePassword = this.onChangePassword.bind(this);
        this.onChangePasswordConfirm = this.onChangePasswordConfirm.bind(this);
        this.onChangeGender = this.onChangeGender.bind(this);
        this.onChangeOrientation = this.onChangeOrientation.bind(this);
    }

    isValidEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    onClickJoin(e) {
        e.preventDefault();

        let email = this.state.email;
        let username = this.state.username;
        let password = this.state.password;
        let passwordConfirm = this.state.passwordConfirm;
        let gender = this.state.gender;
        let isGay = (this.state.orientation === 'gay');

        if (!(email && username && password && passwordConfirm)) {
            alert('all fields are required.');
            return;
        }


        if (!this.isValidEmail(email)) {
            alert('email invalid.');
            return;
        }

        if (password !== passwordConfirm) {
            alert('passwords do not match.');
            return;
        }

        auth.createUserWithEmailAndPassword(email, password)
            .then((user) => {
                return db.ref().child(`users/${user.uid}/info`)
                    .set({
                        username: this.state.username,
                        email: user.email,
                        gender: gender,
                        isGay: isGay,
                        uid: user.uid,
                        lastLoggedInOn: null,
                        createdOn: Date.now()
                    })
            }).then(() => {
                console.log('User joined. User saved. ');
            }).catch((e) => {
                console.log(e);
            });
    }

    onChangeUsername(e) {
        let v = e.target.value;
        this.setState({
            username: v
        })
    }

    onChangeEmail(e) {
        let v = e.target.value;
        this.setState({
            email: v
        })
    }

    onChangePassword(e) {
        let v = e.target.value;
        this.setState({
            password: v
        })
    }

    onChangePasswordConfirm(e) {
        let v = e.target.value;
        this.setState({
            passwordConfirm: v
        })
    }

    onChangeGender(e) {
        let v = e.target.value;
        this.setState({ gender: v });
    }

    onChangeOrientation(e) {
        let v = e.target.value;
        this.setState({ orientation: v });
    }


    render() {
        let styles = {
            paper: {
                width: '70%',
                padding: '5%'
            },
            textfields: {
                width: '100%'
            },
            center: {
                textAlign: 'center'
            },
            link: {
                textDecoration: 'none'
            },
            button: {
                width: '100%'
            },
            select: {
                marginRight: '2%'
            }
        }

        return (
            <Grid container justify="center" spacing={24}>
                <Grid item>
                    <img src="/logo72.png" alt="NDA" style={{ padding: '20%' }} />
                </Grid>
                <Paper style={styles.paper} elevation={0}>
                    <Grid container spacing={8}>
                        <Typography type="headline" component="h3">
                            Join
                        </Typography>
                        <Grid item xs={12} style={styles.center}>
                            <TextField
                                id="username"
                                label="username"
                                value={this.state.username}
                                onChange={this.onChangeUsername}
                                style={styles.textfields}
                            />
                        </Grid>
                        <Grid item xs={12} style={styles.center}>
                            <TextField
                                id="email"
                                label="email"
                                value={this.state.email}
                                onChange={this.onChangeEmail}
                                style={styles.textfields}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                id="select-gender-native"
                                select
                                style={styles.select}
                                label="Gender"
                                value={this.state.gender}
                                onChange={this.onChangeGender}
                                SelectProps={{ native: true }}
                            >
                                <option key="male" value="male">
                                    Male
                                </option>
                                <option key="female" value="female">
                                    Female
                                </option>
                            </TextField>
                            <TextField
                                id="select-orientation-native"
                                select
                                label="Orientation"
                                value={this.state.orientation}
                                onChange={this.onChangeOrientation}
                                SelectProps={{ native: true }}
                            >
                                <option key="straight" value="straight">
                                    Straight
                                </option>
                                <option key="gay" value="gay">
                                    Gay
                                </option>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} style={styles.center}>
                            <TextField
                                id="password"
                                label="password"
                                type="password"
                                value={this.state.password}
                                onChange={this.onChangePassword}
                                style={styles.textfields}
                            />
                        </Grid>
                        <Grid item xs={12} style={styles.center}>
                            <TextField
                                id="passwordConfirm"
                                label="Confirm password"
                                type="password"
                                value={this.state.passwordConfirm}
                                onChange={this.onChangePasswordConfirm}
                                style={styles.textfields}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} style={styles.center}>
                            <Button raised onClick={this.onClickJoin} color="accent" style={styles.button}>
                                join
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={6} style={styles.center}>
                            <Link to="/" style={styles.link}>
                                <Button raised style={styles.button}>
                                    Back
                                </Button>
                            </Link>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        )
    }
}

export default Join;


// WEBPACK FOOTER //
// ./src/Components/join.jsx